import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Puzzle, Download } from "lucide-react";

const STEPS = [
  "Download the add-on. Do not double-click the .zip (Windows may try to open it in Adobe). Instead open your Downloads folder, right-click webdcs-addon.zip and choose Extract All, then Extract. You get a folder named webdcs-addon. If Windows says the file is invalid, delete the old copies, download again and drag the .zip to your Desktop before extracting.",
  "In Chrome open chrome://extensions and turn on Developer mode (top right).",
  "Click Load unpacked and pick the extracted webdcs-addon folder (the one that has manifest.json inside). Pin it from the puzzle-piece menu.",
  "Stay signed in to Warranty Compliance Pro in the same Chrome window.",
  "Open WebDCS Claim Entry/Edit/Submit or a new GWM transaction, click the add-on, pick the portal and store, then press Fill + Save (one draft) or Save all.",
  "The add-on saves drafts only - it never presses Submit. Open each saved draft, finish anything it lists as left blank, then submit it yourself.",
];

export function AddonDialog({ system = "WebDCS" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="hy-addon-button" className="gap-2 border-white/30 bg-white/10 text-white hover:bg-white/20">
        <Puzzle className="h-4 w-4" /> {system} add-on
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="hy-addon-dialog">
          <DialogHeader>
            <DialogTitle>{system} Fill add-on for Chrome</DialogTitle>
            <DialogDescription>One add-on for Hyundai WebDCS and GM GWM - pick the portal at the top of the add-on. It fills the {system} screen from your drafts after you sign in. You review and press Submit.</DialogDescription>
          </DialogHeader>
          <ol className="list-decimal space-y-1.5 pl-5 text-sm">
            {STEPS.map((s) => <li key={s}>{s}</li>)}
          </ol>
          <Button asChild className="gap-2" data-testid="hy-addon-download">
            <a href={`${process.env.PUBLIC_URL || ""}/webdcs-addon.zip`} download><Download className="h-4 w-4" /> Download add-on (.zip)</a>
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
